<template>
  <div>
    <new-main-header v-if="hasNewLeftNavEnabled">
      Account
    </new-main-header>
    <main-header v-else>
      <span slot="arrow-back">
        <el-tooltip
            class="item"
            effect="dark"
            content="Back to Start Page"
            placement="bottom-start">
          <router-link :to="{ name: 'HomePage' }"><i class="el-icon-back" /> </router-link>
        </el-tooltip>
      </span>
      <span slot="page-title">Account</span>
    </main-header>
    <main-content>
      <!--HORIZONTAL MENU-->
      <div
          v-if="false"
          slot="horizontal-menu"
          :style="parentMenuStyle">
        <el-menu
            :default-active="selected.index"
            class="ring-menu--horizontal"
            mode="horizontal"
            @select="selectMenu">
          <el-menu-item
              v-scroll-to="{
                el: '#customer-details',
                container: '#main-content',
                duration: 500,
                easing: 'linear'}"
              index="1">
            {{ $t('details.title') }}
          </el-menu-item>
          <el-menu-item
              v-scroll-to="{
                el: '#customer-locations',
                container: '#main-content',
                duration: 500,
                easing: 'linear'}"
              index="2">
            {{ $t('locations.title') }}
          </el-menu-item>
          <el-menu-item
              v-scroll-to="{
                el: '#customer-invitations',
                container: '#main-content',
                duration: 500,
                easing: 'linear'}"
              index="3">
            {{ $t('invitations.title') }}
          </el-menu-item>
          <el-menu-item
              v-scroll-to="{
                el: '#customer-client-devices',
                container: '#main-content',
                duration: 500,
                easing: 'linear'}"
              index="4">
            {{ $t('client_devices.title') }}
          </el-menu-item>
        </el-menu>
      </div>

      <!--MAIN CONTENT-->
      <div slot="main-content">
        <customer-details
            id="customer-details"
            :customer="customer" />
        <div id="customer-locations">
          <customer-locations :customer="customer" />
        </div>
      </div>
    </main-content>
  </div>
</template>

<script>
import MainContent from "@/containers/Core/MainContent";
import MainHeader from "@/containers/Core/Header/MainHeader";
import NewMainHeader from "@/NewUI/containers/core/header/MainHeader";

import CustomerLocations from "./Profile/Locations";
import CustomerDetails from "./Profile/Details";
import CustomerClientDevices from "./Profile/ClientDevices";
import { createNamespacedHelpers } from "vuex";
import permission from "@/mixins/permission";
const { mapGetters: accountGetters } = createNamespacedHelpers("db/account");

const not = (x) => !x;

export default {
  name: "CustomerProfile",
  components: {
    MainContent,
    MainHeader,
    CustomerLocations,
    CustomerDetails,
    CustomerClientDevices,
    NewMainHeader,
  },
  mixins: [permission],
  data() {
    return {
      parentMenuStyle: {},
      selected: { index: "1" },
    };
  },
  computed: {
    ...accountGetters(["customer"]),
    hasNewLeftNavEnabled() {
      return this.hasPermission("NewUI", "leftNav");
    },
  },
  mounted() {
    if (this.$route.query.hasOwnProperty("location_id"))
      this.selected.index = "2";
  },
  methods: {
    selectMenu(index) {
      this.selected.index = index;
      this.parentMenuStyle = {}; // clue: there was a time where here was a submenu
    },
  },
};
</script>
